// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { CrossratesPlan } from "./CrossratesPlan.js"
import { CustomEvent } from "../../Utils/CustomEvents.js"

export let CrossratesPlans = function (dCache)
{
    this.DCache = dCache
    this.UpdateEvent = new CustomEvent()
    this._fCrossratesPlans = new Object()
}

CrossratesPlans.prototype.GetPlanById = function (id)
{
    return this._fCrossratesPlans[id] || null
}

CrossratesPlans.prototype.Add = function (message)
{
    let plan = this.GetPlanById(message.Id)
    if (!plan)
        plan = this._fCrossratesPlans[message.Id] = new CrossratesPlan(message.Id, this.DCache)

    plan.Update(message)
    this.UpdateEvent.Raise(plan)
}

CrossratesPlans.prototype.Clear = function ()
{
    this._fCrossratesPlans = new Object()
}